    <div>
      <span class="search-echo">
        <span>
          <input matInput [formControl]="search" autocomplete="off" [placeholder]="placeHolder" #titleInput
            class="">
        </span>
        <span class="d-flex justify-content-end"><img src="../.../../../../assets/images/search-ico.svg" alt="search" class="place-end"></span>
        <!-- <button type="submit" *ngIf="search.value" class="people-search-btn" (click)="clearSearch()" title="Clear">
          &#x2715;
        </button> -->
      </span>
    </div>
